import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getStoneDetails, updateStone } from "../../helpers/http_stones_requests";
import { useQuery } from "@tanstack/react-query";

export default function StoneUpdate() {

    const navigate = useNavigate();

    const { id } = useParams();

    const { data, isFetching } = useQuery({ queryKey: ['getStoneDetails', id], queryFn: () => getStoneDetails(id), staleTime: 1000 * 5 });

    const { data: dataList } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Informações",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        updateStone(data, () => navigate('/pedras'));
    };

    return <DynamicFormPage isLoading={isFetching} initialData={dataList} title={"Pedras - Editar"} formFieldList={formFieldList} onCancel={() => navigate(-1)} onSubmit={handleSubmit} />;
};
